/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:07:08
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-01-10 16:26:57
 */
import Konva from "konva"
import { GraphElement } from "../graph-element.js"
import { createFromJSON } from "./help.js"

class PVElement extends GraphElement {
  static fromJSON = createFromJSON(this)
  constructor(topology, x, y, attrs) {
    super(topology, 'pv', x, y, {
      text: '光伏',
      port: true,
      ...attrs
    })

    this.onLoad(() => {
      this.addSun()
    })
  }
  addSun() {
    this.sun = new Konva.Group({
      x: 15,
      y: 15,
    })
    this.g.add(this.sun)

    const num = 10
    const diff = 360 / num


    const circle = new Konva.Circle({
      x: 0,
      y: 0,
      radius: 5,
      stroke: '#35D567',
      strokeWidth: 2,
    })

    this.sun.add(circle)

    for (let angle = 0; angle < 360; angle += diff) {
      let rect = new Konva.Rect({
        x: 0,
        y: 0,
        width: 5,
        height: 2,
        fill: '#35D567',
        rotation: angle,
        cornerRadius: 2,
        offset: {
          x: -8,
          y: 0,
        }
      })
      this.sun.add(rect)
    }

    let angularSpeed = 45
    let anim = new Konva.Animation((frame) => {
      let angleDiff = (frame.timeDiff * angularSpeed) / 1000
      this.sun.rotate(angleDiff)
    }, this.layer)

    anim.start()
  }
}

export { PVElement }
